module.exports = __webpack_public_path__ + "img/middle_6.bea1f2a0.png";